<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">Create {{module}}</h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <router-link :to="{name:'dashboards'}">Dashboards</router-link>
                </li>
                <li class="breadcrumb-item">
                  <router-link :to="{name:table_module}">{{ module }}</router-link>
                </li>
                <li class="breadcrumb-item active">Create</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <form @submit.prevent="submit" class="forms-sample">
        <div class="row">
          <div class="col-md-4">
            <div class="card">
              <div class="card-body">
                <div class="form-group">
                  <label for="exampleInputEmail2">Pilih Customer</label>
                  <b-button
                    class="pull-right btn-sm"
                    @click="getFieldsCustomers"
                    v-b-modal.modal-customers
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </b-button>
                  <hr />
                  <v-select
                    label="usr_fullname"
                    :options="options_customers"
                    :filterable="false"
                    v-model="data_customers"
                    @search="searchAutocompleteCustomers"
                    @input="triggerCustomersCars"
                  ></v-select>
                </div>
                <div class="form-group" v-if="data_customers != ''">
                  <label for="exampleInputEmail2">Pilih Mobil</label>
                  <b-button
                    class="pull-right btn-sm"
                    @click="getFieldsCustomersCars"
                    v-b-modal.modal-customers-cars
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </b-button>
                  <hr />
                  <select
                    required
                    v-model="post.cst_crs_id"
                    class="form-control form-control-sm"
                    @change="runServicesWithFilter"
                  >
                    <option
                      v-for="(item, index) in data_cars"
                      :key="index"
                      :value="item['cst_crs_id']"
                    >{{item['crs_model_name']}} ({{ (item['cst_crs_police_number'] != null) ? item['cst_crs_police_number'] : ' - ' }})</option>
                  </select>
                </div>
                <div v-if="data_cars != undefined && data_cars != ''" class="form-group">
                  <label for="exampleInputUsername2">Jenis Paket</label>
                  <div class="row">
                    <div class="form-check col-6">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          name="membershipRadios"
                          id="membershipRadios1"
                          v-model="post.srv_t_type"
                          @change="changeType"
                          :value="1"
                        />
                        Biasa
                        <i class="input-helper"></i>
                      </label>
                    </div>
                    <div class="form-check col-6">
                      <label class="form-check-label">
                        <input
                          type="radio"
                          class="form-check-input"
                          name="membershipRadios"
                          id="membershipRadios2"
                          v-model="post.srv_t_type"
                          @change="changeType"
                          :value="2"
                        />
                        Paket
                        <i class="input-helper"></i>
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="data_cars != undefined && data_cars != ''" class="form-group row">
                  <label for="exampleInputEmail2" class="col-sm-3 col-form-label">Pilih Paket</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control form-control-sm" />
                  </div>
                </div>
                <table v-if="data_cars != undefined && data_cars != ''" class="table table-hover">
                  <thead>
                    <tr>
                      <th>Nama</th>
                      <th>Harga</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in data_srv" :key="index">
                      <td>{{ (item['srv_name'] != undefined) ? item['srv_name'] : item['srv_b_name'] }}</td>
                      <td>Rp {{ (item['srv_price'] != undefined) ? numberWithCommas(item['srv_price']) : numberWithCommas(item['srv_b_price']) }}</td>
                      <td>
                        <button
                          type="button"
                          @click="addTable(index)"
                          class="btn btn-success btn-sm"
                        >Pilih</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="card">
              <div class="card-body">
                <h4
                  class="card-title"
                >{{ (post.srv_t_type == 1) ? 'List Servis' : 'List Paket Servis'}}</h4>
                <div class="table-responsive">
                  <table class="table table-hover">
                    <thead>
                      <tr>
                        <th>Servis</th>
                        <th>Harga</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="list.length == 0">
                        <td colspan="10" class="text-center">Servis belum dipilih</td>
                      </tr>
                      <tr v-else v-for="(item, index) in list" :key="index">
                        <td>{{ (item['srv_name'] != undefined) ? item['srv_name'] : item['srv_b_name'] }}</td>
                        <td>Rp. {{ (item['srv_price'] != undefined) ? numberWithCommas(item['srv_price']) : numberWithCommas(item['srv_b_price']) }}</td>
                        <td>
                          <a
                            href="javascript:;"
                            @click="deleteList(index)"
                            class="badge badge-danger"
                          >
                            <i class="fa fa-trash" aria-hidden="true"></i>
                            Delete
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Total</th>
                        <th>Rp {{ numberWithCommas(sumTotal) }}</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <br />
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Form Tambahan</h4>
                <div class="form-group row">
                  <label for="exampleInputUsername2" class="col-sm-3 col-form-label">DP</label>
                  <div class="col-sm-9">
                    <currency-input
                      class="form-control form-control-sm"
                      v-model="post.srv_t_dp"
                      @input="sumGrandTotal"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="exampleInputUsername2" class="col-sm-3 col-form-label">Total</label>
                  <div class="col-sm-9">
                    <currency-input
                      class="form-control form-control-sm"
                      v-model="post.srv_t_actual_price"
                      @input="changeActual"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <label for="exampleInputUsername2" class="col-sm-3 col-form-label">Teknisi</label>
                  <div class="col-sm-9">
                    <v-select
                      label="crs_model_name"
                      :options="options_employe"
                      :filterable="false"
                      v-model="data_employe"
                      @search="searchEmploye"
                    ></v-select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="exampleInputUsername2" class="col-sm-3 col-form-label">Catatan</label>
                  <div class="col-sm-9">
                    <textarea
                      class="form-control form-control-sm"
                      id="exampleTextarea1"
                      rows="4"
                      v-model="post.srv_t_note"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 grid-margin mt-3">
            <button type="submit" class="btn btn-primary mr-2">Submit</button>
            <router-link class="btn btn-danger" :to="{name : table_module}">Cancel</router-link>
          </div>
        </div>
      </form>

      <b-modal hide-footer id="modal-customers" ref="modal-customers" title="Tambah Pelanggan">
        <form class="form-sample" @submit.prevent="saveCustomers()">
          <div class="row">
            <div class="col-md-12" v-for="(item, index) in fields_customers" :key="index">
              <div class="form-group">
                <label>{{ item['usr_f_label'] }}</label>
                <small
                  v-if="item['usr_f_validation'] != ''"
                  class="pull-right text-danger"
                >*{{ item['usr_f_validation'] }}</small>
                <component
                  :is="item['usr_f_input_type']+'_form'"
                  :name="item['usr_f_name']"
                  :validation="item['usr_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item['usr_f_options']"
                  @post="bindingDataCustomers"
                ></component>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button type="button" class="btn btn-danger mr-2" @click="hideModal">Batal</button>
        </form>
      </b-modal>

      <b-modal
        hide-footer
        id="modal-customers-cars"
        ref="modal-customers-cars"
        title="Tambah Mobil Pelanggan"
      >
        <form class="form-sample" @submit.prevent="saveCustomersCars()">
          <div class="row">
            <div class="col-md-12" v-for="(item, index) in fields_customers_cars" :key="index">
              <div class="form-group">
                <label>{{ item['cst_crs_f_label'] }}</label>
                <small
                  v-if="item['cst_crs_f_validation'] != ''"
                  class="pull-right text-danger"
                >*{{ item['cst_crs_f_validation'] }}</small>
                <component
                  :is="item['cst_crs_f_input_type']+'_form'"
                  :name="item['cst_crs_f_name']"
                  :validation="item['cst_crs_f_validation']"
                  :content="item['content']"
                  :dropdown_name="item['cst_crs_f_options']"
                  @post="bindingDataCustomersCars"
                  :parsing-post="post_customers_cars"
                  :parsing-trigger="trigger_autocomplete"
                ></component>
              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-primary mr-2">Submit</button>
          <button type="button" class="btn btn-danger mr-2" @click="hideModalCustomersCars">Batal</button>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { _ } from "vue-underscore";
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import year_form from "@/components/input/year";
import s_image_form from "@/components/input/s_image";

// import { Money } from "v-money";

export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      fields: {},
      fields_customers: {},
      fields_customers_cars: {},
      post: {
        srv_t_type: 1,
        srv_t_actual_price: 0,
        srv_t_dp: 0,
        srv_t_cat: 4,
      },
      post_customers: {},
      post_customers_cars: {},
      options_cars: [],
      options: [],
      options_customers: [],
      options_employe: [],
      list: [],
      data_cars: [],
      data_autocomplete: [],
      data_customers: [],
      data_employe: [],
      dd_label: "",
      dd_value: "",
      data_srv: [],
      trigger_autocomplete: "",
      model_cars: "",
    };
  },
  computed: {
    sumTotal() {
      // var vm = this;
      var type = this.getType();
      var total = 0;
      this.list.forEach(function (v) {
        total += v[type + "_price"];
      });

      return total;
    },
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    year_form,
    s_image_form,
  },
  methods: {
    getType() {
      var type = "";
      if (this.post.srv_t_type == 1) {
        type = "srv";
      } else {
        type = "srv_b";
      }

      return type;
    },
    triggerCustomersCars() {
      this.$set(this.post, "usr_id", this.data_customers.usr_id);
      this.$set(this.post_customers_cars, "cst_id", this.data_customers.usr_id);
      this.getCustomersCars();
    },
    getCustomersCars() {
      var params = {};
      params = {
        ["filter[cst_id]"]: this.data_customers.usr_id,
      };

      this.axios
        .get("/dropdown/option/cst_cars_id", { params: params })
        .then((response) => {
          this.data_cars = response.data.data.data;
        });
    },
    searchAutocompleteCustomers(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.search_cst(loading, search, this);
      }
    },
    search: _.debounce((loading, search, vm) => {
      var params = {};
      params = {
        ["search[crs_model_name]"]: search,
      };

      vm.axios
        .get("/dropdown/autocomplete/crs_model_id", { params: params })
        .then((response) => {
          loading(false);
          vm.options_cars = response.data.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    search_cst: _.debounce((loading, search, vm) => {
      var params = {};
      params = {
        ["search[usr_fullname]"]: search,
      };

      vm.axios
        .get("/dropdown/autocomplete/cst_id", { params: params })
        .then((response) => {
          loading(false);
          vm.options_customers = response.data.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    }, 500),
    addTable(index) {
      var vm = this;
      var type = "";
      if (this.post.srv_t_type == 1) {
        type = "srv";
      } else {
        type = "srv_b";
      }

      if (vm.post[type + "_id"] == undefined) {
        vm.post[type + "_id"] = [];
      }

      let find = this.list.findIndex(
        (r) => r[type + "_id"] == vm.data_srv[index][type + "_id"]
      );

      if (find == -1) {
        vm.list.push(vm.data_srv[index]);
        vm.post.srv_t_actual_price += vm.data_srv[index][type + "_price"];
        // vm.$set(vm.post[type + "_id"], type + "_id", vm.data_srv[index][type + "_id"])
        vm.post[type + "_id"].push(vm.data_srv[index][type + "_id"]);
      } else {
        this.$toast.error("Data sudah ditambahkan");
      }
    },
    changeType() {
      this.list = [];
      this.runServices();

      delete this.post["srv_id"];
      delete this.post["srv_b_id"];
    },
    deleteList(k) {
      this.list.splice(k, 1);
    },
    runServicesWithFilter() {
      this.runServices();
    },
    runServices(search = "") {
      var params = {};
      var met = "";
      if (this.post.srv_t_type == 1) {
        params = {
          ["search[srv_name]"]: search,
        };
        met = "srv_id";
      } else {
        params = {
          ["search[srv_b_name]"]: search,
        };
        met = "srv_b_id";
      }

      let find = this.data_cars.findIndex(
        (r) => r["cst_crs_id"] == this.post.cst_crs_id
      );
      if (find != -1) {
        params["filter[crs_model_id]"] = this.data_cars[find].crs_model_id;
      }

      this.axios
        .get("/dropdown/autocomplete/" + met, { params: params })
        .then((response) => {
          this.data_srv = response.data.data.data;
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              console.log("error 500");
            }
          }
        });
    },
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    searchEmploye() {},
    sumGrandTotal(value) {
      if (value != 0) {
        this.post.srv_t_actual_price =
          parseInt(this.sumTotal) - parseInt(value);
      }

      if (value == 0) {
        this.post.srv_t_actual_price = parseInt(this.sumTotal);
      }
    },
    changeActual(value) {
      this.post.srv_t_actual_price = value;
    },
    submit() {
      console.log(this.post);
      // this.axios
      //   .post("/" + this.table_module + "/save", this.post)
      //   .then((response) => {
      //     if (response.data.status == 200) {
      //       this.$toast("Simpan data berhasil");
      //       this.$router.push({ name: this.table_module });
      //     }
      //   });
    },
    hideModal() {
      this.$refs["modal-customers"].hide();
    },
    hideModalCustomersCars() {
      this.$refs["modal-customers-cars"].hide();
    },
    getFieldsCustomers() {
      this.post_customers = {
        usr_password: 123456,
        usr_password_confirm: 123456,
        usr_role: 2,
      };
      this.axios.get("/users/create").then((response) => {
        this.fields_customers = response.data.data;
      });
    },
    getFieldsCustomersCars() {
      var id = this.post_customers_cars.cst_id;
      this.post_customers_cars = {};
      this.$set(this.post_customers_cars, "cst_id", id);
      this.axios.get("/customers_cars/create").then((response) => {
        this.fields_customers_cars = response.data.data;
      });
    },
    bindingDataCustomers: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers, value["name"]);
      } else {
        this.$set(this.post_customers, value["name"], value["value"]);
      }
    },
    bindingDataCustomersCars: function (value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post_customers_cars, value["name"]);
      } else {
        this.$set(this.post_customers_cars, value["name"], value["value"]);
        if (value.name == "crs_brand_id") {
          this.trigger_autocomplete =
            Math.floor(100000 + Math.random() * 900000) + "_crs_model_id";
        }
      }
    },
    saveCustomers() {
      // this.$set(this.post_customers, 'cst_id', this.data_customers.usr_id);
      // this.data_customers.usr_id
      this.axios
        .post("/users/register", this.post_customers)
        .then((response) => {
          if (response.data != "") {
            this.data_customers = response.data.data;
            this.$set(this.post, "usr_id", this.data_customers.usr_id);
            this.$set(
              this.post_customers_cars,
              "cst_id",
              this.data_customers.usr_id
            );
            this.getCustomersCars();
            this.hideModal();
          }
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    },
    saveCustomersCars() {
      this.axios
        .post("/customers_cars/save", this.post_customers_cars)
        .then((response) => {
          if (response.data != "") {
            this.data_cars.push(response.data.data.customers_cars);
            this.hideModalCustomersCars();
          }
        })
        .catch((error) => {
          this.disabled = false;
          if (error.response.data.error != undefined) {
            this.error = error.response.data.error;
          } else {
            this.error = error.response.data;
          }
        });
    },
  },
};
</script>